export default {
      id: "calling-dialpad-usage",
      viewBox: "0 0 18 18",
      url: "/dist/svg/" + "sprite.svg#calling-dialpad-usage",
      toString: function () {
        return this.url;
      }
    }